var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":_vm.data.d}})
}
var staticRenderFns = []

export { render, staticRenderFns }